import { render, staticRenderFns } from "./aftersaleOEM.vue?vue&type=template&id=6aaf3412&"
import script from "./aftersaleOEM.vue?vue&type=script&lang=ts&"
export * from "./aftersaleOEM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports